(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var headerWrapper = document.querySelector('.header-wrapper');
    var heroVideo = document.querySelector('.hero-video-fullscreen');
    if (!headerWrapper) return;

    var isTransparentPage = !!heroVideo && heroVideo.closest('main') && heroVideo.closest('main').firstElementChild === heroVideo;

    if (isTransparentPage) {
      headerWrapper.classList.add('header--transparent-enabled');
      document.body.classList.add('rhode-has-transparent-header');
    }

    function getScrollThreshold() {
      if (heroVideo) return Math.max(heroVideo.offsetHeight * 0.7, 80);
      return 80;
    }

    var threshold = getScrollThreshold();
    var ticking = false;

    function updateHeaderState() {
      var scrolled = window.scrollY > threshold;
      headerWrapper.classList.toggle('header--scrolled', scrolled);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderState);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      threshold = getScrollThreshold();
      updateHeaderState();
    });

    updateHeaderState();
  });
})();
